import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1ccaa324"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "suggestion-details-messages" };
const _hoisted_2 = { class: "sdc__header" };
const _hoisted_3 = { class: "m-0" };
const _hoisted_4 = {
    key: 0,
    class: "required"
};
const _hoisted_5 = {
    key: 2,
    class: "suggestion-details-messages__empty"
};
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = {
    key: 3,
    class: "sdc__table customScrollBar"
};
const _hoisted_8 = { class: "table" };
const _hoisted_9 = { class: "table__header" };
const _hoisted_10 = { class: "table__row" };
const _hoisted_11 = { class: "table__column" };
const _hoisted_12 = { class: "table__header-title" };
const _hoisted_13 = { class: "table__column text-right" };
const _hoisted_14 = { class: "table__header-title" };
const _hoisted_15 = {
    key: 0,
    class: "table__column text-right"
};
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "table__header-title" }, null, -1));
const _hoisted_17 = [
    _hoisted_16
];
const _hoisted_18 = { class: "table__body" };
const _hoisted_19 = {
    class: "table__row table__row--first",
    style: { "align-items": "flex-start" }
};
const _hoisted_20 = {
    class: /*#__PURE__*/ _normalizeClass(['table__column text-left'])
};
const _hoisted_21 = {
    class: /*#__PURE__*/ _normalizeClass(['table__column text-left'])
};
const _hoisted_22 = {
    class: /*#__PURE__*/ _normalizeClass(['table__column'])
};
const _hoisted_23 = ["innerHTML"];
const _hoisted_24 = ["onClick"];
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "active-actions-table__dropdown__button" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-menu-14px" })
], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_alert = _resolveComponent("alert");
    const _component_actions_new_message_modal = _resolveComponent("actions-new-message-modal");
    const _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
    const _component_el_skeleton = _resolveComponent("el-skeleton");
    const _component_el_popover = _resolveComponent("el-popover");
    const _component_el_table_column = _resolveComponent("el-table-column");
    const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
    const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
    const _component_el_dropdown = _resolveComponent("el-dropdown");
    const _component_el_table = _resolveComponent("el-table");
    const _directive_tooltip = _resolveDirective("tooltip");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h3", _hoisted_3, [
                _createTextVNode(_toDisplayString(_ctx.$t('360.campaigns.messages-actions.title')) + " ", 1),
                (_ctx.automaticAction.sendChannel === _ctx.channel.NON_OFFICIAL)
                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_4, [
                        _createTextVNode(" *")
                    ])), [
                        [
                            _directive_tooltip,
                            {
                                theme: 'error',
                                html: true,
                                autoHide: false,
                                distance: 8,
                                content: _ctx.$t('campaigns.required-section'),
                                shown: !_ctx.actionsMessages.length && _ctx.tooltipEmptyError.messages && _ctx.isAutomaticAction,
                            },
                            void 0,
                            { right: true }
                        ]
                    ])
                    : _createCommentVNode("", true)
            ]),
            (_ctx.actionTemplatesList.length && _ctx.automaticAction.sendChannel === _ctx.channel.NON_OFFICIAL)
                ? _withDirectives((_openBlock(), _createElementBlock("strong", {
                    key: 0,
                    class: "suggestion-details-messages__link",
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => (_ctx.createMessage && _ctx.createMessage(...args)))
                }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('360.campaigns.details.add-message')), 1)
                ])), [
                    [
                        _directive_tooltip,
                        {
                            theme: 'error',
                            html: true,
                            autoHide: false,
                            distance: 8,
                            content: _ctx.$t('360.campaigns.details.insufficient-messages'),
                            shown: _ctx.actionsMessages.length < 10 && _ctx.actionsMessages.length > 0 && _ctx.tooltipEmptyError.messages,
                        },
                        void 0,
                        { right: true }
                    ]
                ])
                : _createCommentVNode("", true)
        ]),
        (_ctx.isBelowMessageLimit)
            ? (_openBlock(), _createBlock(_component_alert, {
                key: 0,
                class: "suggestion-details-messages__alert",
                type: "warning",
                message: _ctx.$t('360.campaigns.details.alert-action-message', { count: _ctx.actionTemplatesList.length })
            }, null, 8, ["message"]))
            : _createCommentVNode("", true),
        (_ctx.actionTemplatesList.length >= 10 && _ctx.automaticAction.sendChannel === _ctx.channel.NON_OFFICIAL)
            ? (_openBlock(), _createBlock(_component_alert, {
                key: 1,
                class: "suggestion-details-messages__alert",
                type: "success",
                message: _ctx.$t('360.campaigns.details.alert-success-message', { count: _ctx.actionTemplatesList.length })
            }, null, 8, ["message"]))
            : _createCommentVNode("", true),
        _createVNode(_component_actions_new_message_modal),
        (!_ctx.actionTemplatesList.length && _ctx.isAutomaticAction)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("span", {
                    innerHTML: _ctx.$t('360.campaigns.details.empty-actions-messages')
                }, null, 8, _hoisted_6),
                _createElementVNode("strong", {
                    onClick: _cache[1] || (_cache[1] =
                        //@ts-ignore
                        (...args) => (_ctx.createMessage && _ctx.createMessage(...args))),
                    class: "suggestion-details-messages__link"
                }, _toDisplayString(_ctx.$t('360.campaigns.details.register-message')), 1)
            ]))
            : (_ctx.getLoadingActionTemplates)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('_message', 2)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('created-in')), 1)
                                ]),
                                (_ctx.automaticAction.sendChannel === _ctx.channel.NON_OFFICIAL)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, [
                                    _createVNode(_component_el_skeleton, {
                                        loading: true,
                                        animated: ""
                                    }, {
                                        template: _withCtx(() => [
                                            _createVNode(_component_el_skeleton_item, {
                                                variant: "p",
                                                style: { "height": "10px", "width": "180px", "display": "block", "margin-bottom": "8px" }
                                            }),
                                            _createVNode(_component_el_skeleton_item, {
                                                variant: "p",
                                                style: { "height": "10px", "width": "180px", "display": "block" }
                                            })
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _createElementVNode("div", _hoisted_21, [
                                    _createVNode(_component_el_skeleton, {
                                        loading: true,
                                        animated: ""
                                    }, {
                                        template: _withCtx(() => [
                                            _createVNode(_component_el_skeleton_item, {
                                                variant: "p",
                                                style: { "height": "10px", "width": "80px", "margin-top": "8px" }
                                            })
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _createElementVNode("div", _hoisted_22, [
                                    _createVNode(_component_el_skeleton, {
                                        loading: true,
                                        animated: ""
                                    }, {
                                        template: _withCtx(() => [
                                            _createVNode(_component_el_skeleton_item, {
                                                variant: "p",
                                                style: { "height": "10px", "width": "80px", "margin-top": "8px" }
                                            })
                                        ]),
                                        _: 1
                                    })
                                ])
                            ])
                        ])
                    ])
                ]))
                : _createCommentVNode("", true),
        (_ctx.hasTemplates && !_ctx.getLoadingActionTemplates)
            ? (_openBlock(), _createBlock(_component_el_table, {
                key: 4,
                data: _ctx.actionTemplatesList,
                "table-layout": "auto"
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                        prop: "text",
                        label: _ctx.$tc('_message', 2),
                        width: "650"
                    }, {
                        default: _withCtx(({ row }) => [
                            _createVNode(_component_el_popover, {
                                effect: "dark",
                                trigger: "hover",
                                placement: "top",
                                width: 300
                            }, {
                                reference: _withCtx(() => [
                                    _createElementVNode("span", {
                                        class: "message-text-truncated",
                                        onClick: ($event) => (_ctx.editMessage(row))
                                    }, _toDisplayString(row.text), 9, _hoisted_24)
                                ]),
                                default: _withCtx(() => [
                                    _createElementVNode("p", {
                                        innerHTML: row.text?.replaceAll('\n', '<br />')
                                    }, null, 8, _hoisted_23)
                                ]),
                                _: 2
                            }, 1024)
                        ]),
                        _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                        prop: "createdAt",
                        label: _ctx.$t('created-in')
                    }, {
                        default: _withCtx(({ row }) => [
                            _createElementVNode("span", null, _toDisplayString(_ctx.getCreatedDate(row.createdAt)), 1)
                        ]),
                        _: 1
                    }, 8, ["label"]),
                    (_ctx.automaticAction.sendChannel === _ctx.channel.NON_OFFICIAL)
                        ? (_openBlock(), _createBlock(_component_el_table_column, { key: 0 }, {
                            default: _withCtx(({ row }) => [
                                _createVNode(_component_el_dropdown, {
                                    trigger: "click",
                                    class: "active-actions-table__dropdown"
                                }, {
                                    dropdown: _withCtx(() => [
                                        _createVNode(_component_el_dropdown_menu, null, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_el_dropdown_item, {
                                                    onClick: ($event) => (_ctx.editMessage(row))
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t('edit')), 1)
                                                    ]),
                                                    _: 2
                                                }, 1032, ["onClick"]),
                                                _createVNode(_component_el_dropdown_item, {
                                                    onClick: ($event) => (_ctx.deleteMessage(row)),
                                                    disabled: _ctx.isEditRoute || _ctx.actionTemplatesList.length <= _ctx.TOTAL_MESSAGES
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t('delete')), 1)
                                                    ]),
                                                    _: 2
                                                }, 1032, ["onClick", "disabled"])
                                            ]),
                                            _: 2
                                        }, 1024)
                                    ]),
                                    default: _withCtx(() => [
                                        _hoisted_25
                                    ]),
                                    _: 2
                                }, 1024)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }, 8, ["data"]))
            : _createCommentVNode("", true)
    ]));
}
